<template>
  <SportFeaturePlaceholder
    sport-label="Volleyball"
    title="Edit Volleyball Team"
    description="Volleyball team editing now has a dedicated route and component, aligned with basketball module structure."
    primary-cta="Open Volleyball Dashboard"
    :primary-route="{ name: 'VolleyballTeamDashboard' }"
    :back-route="{ name: 'VolleyballTeamDashboard' }"
  />
</template>

<script>
import SportFeaturePlaceholder from "@/routes/match_hub/shared/SportFeaturePlaceholder.vue";
export default { name: "VolleyballTeamEdit", components: { SportFeaturePlaceholder } };
</script>
